document.addEventListener("turbolinks:load", function () {
  var account_id = $("body").attr("data-account-id");

  if (account_id) {
    if (!window.account || account.id + "" !== account_id) {
      $.getJSON(
        window.location.origin + "/accounts/" + account_id,
        function (data) {
          if (data) {
            window.account = data;
            onboard.checklist.initialize();
          }
        }
      );
    } else {
      onboard.checklist.initialize();
    }
  } else {
    window.account = undefined;
  }

  if (
    $("body").attr("data-controller") == "accounts" &&
    $("body").attr("data-action") == "edit"
  ) {
    $(function () {
      $('[data-toggle="popover"]').popover();
    });

    $("#benchmark_reporting_switch").click(function () {
      $("#benchmark_reporting").click();
    });

    $("#benchmark_reporting").on("change", function () {
      $("#account_benchmarking_opted_out")
        .attr("name", "account[benchmarking_opted_out]")
        .val($(this).is(":checked") ? "false" : "true");
    });
  }

  if (
    $("body").attr("data-controller") == "accounts" &&
    ["partner", "funnels"].includes($("body").attr("data-action"))
  ) {
    if (window.convertflow) {
      convertflow.start();
    } else {
      var script = document.createElement("script");
      script.async = true;
      script.src = "https://js.convertflow.co/production/websites/3.js";
      document.body.appendChild(script);
    }

    var tab = getParameterByName("tab");
    if (tab) {
      $('a[aria-controls="' + tab + '"]').click();
    }
  }

  if (
    $("body").attr("data-controller") == "accounts" &&
    $("body").attr("data-action") == "cancel"
  ) {
    $("#schedule-nevermind").on("click", function () {
      $(".cancel-step").hide();
      $('.cancel-step[data-step="call-scheduled"]').show();
    });

    $("#confirmation-nevermind, #websites-nevermind").on(
      "click",
      function () {
        $(".cancel-step").hide();
        $('.cancel-step[data-step="nevermind"]').show();
      }
    );

    $("#schedule-continue").on("click", function () {
      $(".cancel-step").hide();
      $('.cancel-step[data-step="why"]').show();
    });

    $('.cancel-step[data-step="why"] .cancel-feedback').on(
      "submit",
      function (e) {
        e.preventDefault();
        $.ajax({
          type: "POST",
          url: "cancel_feedback",
          data: $(this).serialize(),
        });

        $(".cancel-step").hide();
        $('.cancel-step[data-step="feedback"]').show();
      }
    );

    $('.cancel-step[data-step="feedback"] .cancel-feedback').on(
      "submit",
      function (e) {
        e.preventDefault();
        $.ajax({
          type: "POST",
          url: "cancel_feedback",
          data: $(this).serialize(),
        });

        const benefitsStep = $('.cancel-step[data-step="benefits"]');

        $(".cancel-step").hide();
        if (benefitsStep.length > 0) {
          benefitsStep.show();
        } else {
          $('.cancel-step[data-step="confirmation"]').show();
        }
      }
    );

    $("#benefits-confirmation").on("click", function () {
      $(".cancel-step").hide();
      $('.cancel-step[data-step="confirmation"]').show();
    });

    $("#confirmation-continue").on("click", function () {
      window.location.href = "downgrade";
    });

    $("#request-cancel button").on("click", function () {
      $.ajax({
        type: "POST",
        url: "request_churn",
      });

      $("#request-cancel").text("Request sent! We'll be in touch soon.");
    });
  }

  // schedule onboarding wizard (post-checkout)
  var scheduleOnboarding = $("#schedule-onboarding");
  if (scheduleOnboarding.length) {
    var scheduleSteps = scheduleOnboarding.find(".schedule-onboarding-step");
    scheduleSteps.hide();
    scheduleSteps.first().show();

    function normalizeInviteEmail(email) {
      return $.trim(email || "")
        .replace(/\s+/g, "")
        .toLowerCase();
    }

    function isValidInviteEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function showInviteMessage(text, isError) {
      $("#schedule-onboarding-invite-message")
        .toggleClass("error-message", !!isError)
        .text(text)
        .show();
    }

    function updateInviteEmailField(input) {
      var field = $(input);
      var email = normalizeInviteEmail(field.val());

      if (field.val() !== email) {
        field.val(email);
      }

      if (email && !isValidInviteEmail(email)) {
        field.addClass("error");
        return false;
      }

      field.removeClass("error");
      return !email || isValidInviteEmail(email);
    }

    function validateInviteEmailsForContinue() {
      var invalid = false;

      $(
        "#schedule-onboarding-invite-rows .schedule-onboarding-invite-row"
      ).each(function () {
        if (
          !updateInviteEmailField(
            $(this).find(".schedule-onboarding-invite-email")
          )
        ) {
          invalid = true;
        }
      });

      if (invalid) {
        showInviteMessage(
          "Fix invalid email addresses before continuing.",
          true
        );
        return false;
      }

      $("#schedule-onboarding-invite-message")
        .hide()
        .removeClass("error-message");
      return true;
    }

    scheduleOnboarding
      .find(".schedule-onboarding-done")
      .off("click.scheduleOnboarding")
      .on("click.scheduleOnboarding", function () {
        var currentStep = $(this).closest(".schedule-onboarding-step");
        var nextStep = currentStep.nextAll(".schedule-onboarding-step").first();

        if (
          currentStep.data("step") === "invite" &&
          !validateInviteEmailsForContinue()
        ) {
          return;
        }

        if (nextStep.length) {
          currentStep.hide();
          nextStep.show();
          window.scrollTo(0, 0);
        } else {
          window.location.href = scheduleOnboarding.attr("data-exit-url");
        }
      });

    function addInviteRow() {
      var template = document.getElementById(
        "schedule-onboarding-invite-row-template"
      );
      if (!template) return;

      var row = $(template.content.cloneNode(true));
      $("#schedule-onboarding-invite-rows").append(row);
    }

    function sendInvite(url, accountId, email, userType, description) {
      return $.ajax({
        type: "POST",
        url: url,
        data: {
          email: email,
          user_type: userType,
          description: description,
          accounts_users: { account_id: accountId },
        },
        dataType: "json",
        headers: {
          Accept: "application/json",
          "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content"),
        },
      });
    }

    $("#schedule-onboarding-invite-add")
      .off("click.scheduleOnboarding")
      .on("click.scheduleOnboarding", function (e) {
        e.preventDefault();
        addInviteRow();
      });

    $("#schedule-onboarding-invite-rows")
      .off(
        "input.scheduleOnboarding blur.scheduleOnboarding",
        ".schedule-onboarding-invite-email"
      )
      .on(
        "input.scheduleOnboarding blur.scheduleOnboarding",
        ".schedule-onboarding-invite-email",
        function () {
          updateInviteEmailField(this);
        }
      );

    $("#schedule-onboarding-invite-rows")
      .off("click.scheduleOnboarding", ".schedule-onboarding-invite-send")
      .on(
        "click.scheduleOnboarding",
        ".schedule-onboarding-invite-send",
        function () {
          var button = $(this);
          var row = button.closest(".schedule-onboarding-invite-row");
          var form = $("#schedule-onboarding-invite-form");
          var input = row.find(".schedule-onboarding-invite-email");
          var email = normalizeInviteEmail(input.val());
          var userType =
            row.find(".schedule-onboarding-invite-role").val() || "admin";
          var description =
            row.find(".schedule-onboarding-invite-description").val() ||
            "team_member";
          var originalLabel = button.text();

          input.val(email);

          if (!email) {
            input.addClass("error");
            showInviteMessage("Enter an email address to invite.", true);
            return;
          }

          if (!isValidInviteEmail(email)) {
            input.addClass("error");
            showInviteMessage("Enter a valid email address.", true);
            return;
          }

          input.removeClass("error");
          button.attr("disabled", "disabled").text("Sending...");

          sendInvite(
            form.attr("action"),
            form.attr("data-account-id"),
            email,
            userType,
            description
          )
            .done(function (data) {
              if (data && data.already_invited) {
                showInviteMessage(email + " is already on this account.", true);
                button.removeAttr("disabled").text(originalLabel);
                return;
              }

              showInviteMessage("Invited " + email + ".", false);
              input.attr("disabled", "disabled");
              row
                .find(".schedule-onboarding-invite-role")
                .attr("disabled", "disabled");
              row
                .find(".schedule-onboarding-invite-description")
                .attr("disabled", "disabled");
              button.attr("disabled", "disabled").text("Sent!");
              row.addClass("schedule-onboarding-invite-row-sent");
            })
            .fail(function () {
              showInviteMessage("Could not invite " + email + ".", true);
              button.removeAttr("disabled").text(originalLabel);
            });
        }
      );

    $("#schedule-onboarding-invite-form")
      .off("submit.scheduleOnboarding")
      .on("submit.scheduleOnboarding", function (e) {
        e.preventDefault();
      });
  }

  // onboarding modal
  $("#onboardingModal").modal("show");
  $(".onboarding-step").first().show();

  var BRAND_ONBOARDING_POLL_MS = 1500;
  var BRAND_ONBOARDING_TIMEOUT_MS = 60000;

  function updateOnboardingSidebar(activeQuestion) {
    var modal = $(".onboarding-modal");
    var dialog = $("#onboardingModal .onboarding-modal-dialog");
    var sidebar = $(".onboarding-modal-testimonial-col");
    var testimonial = $("#onboarding-testimonial");
    var partnerCalendar = $("#onboarding-partner-calendar");
    var showPartnerScheduler = activeQuestion === "partner_kickoff";
    var showWideStep =
      activeQuestion === "integrations" ||
      activeQuestion === "invite" ||
      activeQuestion === "ai_build";

    modal.toggleClass("onboarding-modal--partner", showPartnerScheduler);
    modal.toggleClass("onboarding-modal--wide", showWideStep);
    dialog.toggleClass("onboarding-modal-dialog--partner", showPartnerScheduler);
    dialog.toggleClass("onboarding-modal-dialog--wide", showWideStep);

    if (!sidebar.length) return;

    if (showPartnerScheduler) {
      sidebar.css("display", "flex");
      testimonial.hide();
      partnerCalendar.css("display", "flex");
    } else {
      partnerCalendar.hide();
      testimonial.hide();
      sidebar.hide();
    }
  }

  function remountReactComponent(el, propUpdates) {
    if (!el || !window.ReactRailsUJS) return;

    var props = {};
    try {
      props = JSON.parse(el.getAttribute("data-react-props") || "{}");
    } catch (e) {
      props = {};
    }

    var websiteData = propUpdates.websiteData;
    Object.keys(propUpdates).forEach(function (key) {
      if (key === "websiteData") return;
      props[key] = propUpdates[key];
    });

    if (websiteData && props.website) {
      props.website = Object.assign({}, props.website, {
        data: Object.assign({}, props.website.data || {}, websiteData),
      });
    }

    el.setAttribute("data-react-props", JSON.stringify(props));
    window.ReactRailsUJS.unmountComponents(el);
    window.ReactRailsUJS.mountComponents(el.parentNode);
  }

  function findReactComponentByName(reactClass, inputName) {
    var match = null;
    $('[data-react-class="' + reactClass + '"]').each(function () {
      try {
        var props = JSON.parse(this.getAttribute("data-react-props") || "{}");
        if (props.name === inputName) {
          match = this;
          return false;
        }
      } catch (e) {
        // ignore malformed props
      }
    });
    return match;
  }

  function snapshotBrandFieldValues($step) {
    var snapshot = {};
    $step.find("textarea[name], input[name], select[name]").each(function () {
      if (!this.name) return;
      snapshot[this.name] = $(this).val() || "";
    });
    return snapshot;
  }

  function brandFieldUnchanged($step, name, snapshot) {
    var $field = $step.find('[name="' + name + '"]');
    if (!$field.length) return true;
    return ($field.val() || "") === (snapshot[name] || "");
  }

  function hydrateBrandStylingFields($step, styling, snapshot) {
    if (!styling) return;

    var websiteData = {};
    [
      "brand_font_headline",
      "brand_font_paragraph",
      "brand_color_light",
      "brand_color_vibrant",
      "brand_color_dark",
    ].forEach(function (key) {
      if (styling[key]) websiteData[key] = styling[key];
    });

    if (
      styling.brand_font_headline &&
      brandFieldUnchanged($step, "website[data][brand_font_headline]", snapshot)
    ) {
      remountReactComponent(
        findReactComponentByName(
          "shared/forms/CFFontFamilySelect",
          "website[data][brand_font_headline]"
        ),
        { value: styling.brand_font_headline, websiteData: websiteData }
      );
    }

    if (
      styling.brand_font_paragraph &&
      brandFieldUnchanged(
        $step,
        "website[data][brand_font_paragraph]",
        snapshot
      )
    ) {
      remountReactComponent(
        findReactComponentByName(
          "shared/forms/CFFontFamilySelect",
          "website[data][brand_font_paragraph]"
        ),
        { value: styling.brand_font_paragraph, websiteData: websiteData }
      );
    }

    ["brand_color_light", "brand_color_vibrant", "brand_color_dark"].forEach(
      function (key) {
        if (!styling[key]) return;
        if (
          !brandFieldUnchanged($step, "website[data][" + key + "]", snapshot)
        ) {
          return;
        }
        remountReactComponent(
          findReactComponentByName(
            "shared/forms/CFColorPicker",
            "website[data][" + key + "]"
          ),
          { value: styling[key], websiteData: websiteData }
        );
      }
    );
  }

  function hydrateBrandResearchFields($step, research, snapshot) {
    if (!research) return;

    if (
      research["brand-description"] &&
      brandFieldUnchanged($step, "website[data][brand-description]", snapshot)
    ) {
      $step
        .find('textarea[name="website[data][brand-description]"]')
        .val(research["brand-description"]);
    }

    if (
      research.vertical &&
      brandFieldUnchanged($step, "website[data][vertical]", snapshot)
    ) {
      $step.find('select[name="website[data][vertical]"]').val(research.vertical);
    }

    if (
      research.brand_tone &&
      brandFieldUnchanged($step, "website[data][brand_tone]", snapshot)
    ) {
      $step
        .find('textarea[name="website[data][brand_tone]"]')
        .val(research.brand_tone);
    }
  }

  function maybeHydrateBrandData(question, $step) {
    var statusUrl = $(".onboarding-modal").attr(
      "data-brand-onboarding-status-url"
    );
    if (!statusUrl || !$step.length) return;

    var readyAttr =
      question === "brand_styling"
        ? "data-styling-ready"
        : question === "remix_settings"
        ? "data-research-ready"
        : null;

    if (!readyAttr || $step.attr(readyAttr) === "true") return;

    var readyKey =
      question === "brand_styling" ? "styling_ready" : "research_ready";
    var startedAt = Date.now();
    var fieldSnapshot = snapshotBrandFieldValues($step);

    function applyStatus(status) {
      if (!status) return;

      if (question === "brand_styling") {
        hydrateBrandStylingFields($step, status.styling, fieldSnapshot);
        if (status.styling_ready) $step.attr("data-styling-ready", "true");
      } else {
        hydrateBrandResearchFields($step, status.research, fieldSnapshot);
        if (status.research_ready) $step.attr("data-research-ready", "true");
      }
    }

    function poll() {
      $.getJSON(statusUrl)
        .done(function (status) {
          if (status && status[readyKey]) {
            applyStatus(status);
            return;
          }

          if (Date.now() - startedAt >= BRAND_ONBOARDING_TIMEOUT_MS) {
            return;
          }

          setTimeout(poll, BRAND_ONBOARDING_POLL_MS);
        })
        .fail(function () {
          if (Date.now() - startedAt >= BRAND_ONBOARDING_TIMEOUT_MS) {
            return;
          }

          setTimeout(poll, BRAND_ONBOARDING_POLL_MS);
        });
    }

    poll();
  }

  updateOnboardingSidebar($(".onboarding-step").first().attr("data-question"));

  $(".onboarding-step").each(function (i, question_div) {
    var question = $(question_div).attr("data-question");

    function showNextStep(next_question) {
      $(question_div).hide();
      var next_step = $(
        '.onboarding-step[data-question="' + next_question + '"]'
      )[0];

      if (next_step) {
        $(next_step).show();
        updateOnboardingSidebar(next_question);
        maybeHydrateBrandData(next_question, $(next_step));
      } else {
        $("#onboardingModal").modal("hide");
        setTimeout(function () {
          var isModal = $("#onboardingModal").length > 0;

          if (isModal) {
            window.location.reload();
          } else {
            let name = $('[name="user[name]').val();
            let lastname = $('[name="user[lastname]').val();
            let company = $('[name="user[company]').val();
            let website = $('[name="user[website]').val();
            let isAgency = $('[name="user[data][agency]"]').val();
            let businessType = $('[name="user[data][business_type]"]').val();
            let trafficEstimate = $(
              '[name="user[data][traffic_estimate]"]'
            ).val();
            let queryStrings = `?name=${name}&lastname=${lastname}&company_name=${company}&url=${website}&industry=${
              isAgency ? "agency" : businessType
            }&traffic_estimate=${trafficEstimate}`;

            const isProductionHost =
              window.location.hostname.indexOf("app.convertflow.com") > -1;

            window.location.href = isProductionHost
              ? `https://pages.convertflow.com/gopro${queryStrings}`
              : "/accounts/onboarding?onboarding_step=campaign";
          }
        }, 500);
      }
    }

    $(question_div)
      .find("form")
      .on("submit", function () {
        var next_question = $(this).attr("data-next");

        if (next_question) {
          showNextStep(next_question);
        }
      });

    $(question_div)
      .find(".onboarding-step-continue")
      .on("click", function () {
        var next_question = $(this).attr("data-next");

        if ($(this).attr("data-invite-finish") === "true") {
          if (!validateOnboardingInviteEmails()) {
            return;
          }
          next_question = "";
        }

        showNextStep(next_question);
      });

    $(question_div)
      .find(".onboarding-step-survey")
      .on("click", function () {
        var answer = $(this).attr("data-answer");
        var next_question = $(this).attr("data-next");
        var input = $(question_div).find(".onboard-step-survey-input");

        if (input) {
          $(input).val(answer);
          $(question_div).find("form").trigger("submit.rails");
        }

        showNextStep(next_question);
      });

    if (question === "conversion_goal") {
      var $goalStep = $(question_div);
      var $goalChoices = $goalStep.find(".onboarding-conversion-goal-choices");
      var $goalName = $goalStep.find(".onboarding-conversion-goal-name");
      var $goalInput = $goalStep.find(".onboard-step-survey-input");
      var $goalNameInput = $goalStep.find(
        '[name="website[data][reporting-custom-goal-name]"]'
      );
      var $goalHeading = $goalStep.find("h3").first();
      var $goalSubcopy = $goalStep.find("p.light").first();
      var goalHeading = $.trim($goalHeading.text());
      var goalSubcopy = $.trim($goalSubcopy.text());
      var goalForm = $goalStep.find("form")[0];

      var showGoalChoices = function () {
        $goalInput.val("");
        $goalName.hide();
        $goalChoices.show();
        $goalHeading.text(goalHeading);
        $goalSubcopy.text(goalSubcopy);
        $goalStep.find(".onboarding-conversion-goal-error").hide();
        $goalNameInput.prop("disabled", true);
      };

      var showCustomGoalLabel = function () {
        $goalInput.val(JSON.stringify(["custom"]));
        $goalNameInput.prop("disabled", false);
        $goalChoices.hide();
        $goalHeading.text(
          "What label should ConvertFlow use for this custom goal?"
        );
        $goalSubcopy.text(
          "Reports and insights for this website will count this goal."
        );
        $goalName.show();
        $goalStep.find(".onboarding-conversion-goal-error").hide();
        $goalNameInput.trigger("focus");
      };

      $goalStep.find(".onboarding-conversion-goal").on("click", function () {
        var goal = $(this).attr("data-goal");

        if (goal === "custom") {
          showCustomGoalLabel();
          return;
        }

        $goalNameInput.prop("disabled", true);
        $goalInput.val(JSON.stringify([goal]));
        goalForm.requestSubmit();
        showNextStep("brand_styling");
      });

      $goalStep.find(".onboarding-conversion-goal-back").on("click", function () {
        showGoalChoices();
      });

      goalForm.addEventListener(
        "submit",
        function (event) {
          if ($goalName.is(":hidden")) return;

          var name = $.trim($goalNameInput.val());
          if (!name) {
            event.preventDefault();
            event.stopPropagation();
            $goalStep.find(".onboarding-conversion-goal-error").show();
            $goalNameInput.trigger("focus");
            return;
          }

          $goalNameInput.val(name);
          $goalInput.val(JSON.stringify(["custom"]));
          $goalNameInput.prop("disabled", false);
          showNextStep("brand_styling");
        },
        true
      );
    }

    if (question === "ai_build") {
      var MAX_ONBOARDING_PLAYBOOKS = 1;

      function selectOnboardingPlaybook(selected) {
        $(question_div)
          .find(".onboarding-playbook-toggle")
          .prop("checked", false);
        $(selected).prop("checked", true);
      }

      $(question_div)
        .find(".onboarding-playbook-pick")
        .on("click", function (e) {
          e.preventDefault();
          var selected = $(this).find(".onboarding-playbook-toggle")[0];
          if (!selected || selected.disabled) return;
          selectOnboardingPlaybook(selected);
        });

      $(question_div)
        .find(".onboarding-playbook-approve")
        .on("click", function () {
          var $buttons = $(question_div).find(".onboarding-playbook-approve");
          if ($buttons.prop("disabled")) return;

          var playbookIds = $(question_div)
            .find(".onboarding-playbook-toggle:checked")
            .map(function () {
              return $(this).val();
            })
            .get()
            .filter(Boolean)
            .slice(0, MAX_ONBOARDING_PLAYBOOKS);
          var remixUrl = $(question_div).attr("data-remix-url");

          $buttons.prop("disabled", true);
          $(question_div).find(".onboarding-playbook-toggle").prop("disabled", true);
          $(question_div).find(".onboarding-playbook-error").hide();
          if (playbookIds.length && remixUrl) {
            $.ajax({
              url: remixUrl,
              method: "POST",
              contentType: "application/json",
              dataType: "json",
              headers: {
                "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content"),
              },
              data: JSON.stringify({ playbook_ids: playbookIds }),
            })
              .done(function () {
                showNextStep("integrations");
              })
              .fail(function () {
                $buttons.prop("disabled", false);
                $(question_div)
                  .find(".onboarding-playbook-toggle")
                  .prop("disabled", false);
                $(question_div).find(".onboarding-playbook-error").show();
              });
          } else {
            showNextStep("integrations");
          }
        });

      $(question_div)
        .find(".onboarding-playbook-skip")
        .on("click", function () {
          showNextStep("integrations");
        });
    }
  });

  function normalizeOnboardingInviteEmail(email) {
    return $.trim(email || "")
      .replace(/\s+/g, "")
      .toLowerCase();
  }

  function isValidOnboardingInviteEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function showOnboardingInviteMessage(text, isError) {
    $("#onboarding-invite-message")
      .toggleClass("error-message", !!isError)
      .text(text)
      .show();
  }

  function updateOnboardingInviteEmailField(input) {
    var field = $(input);
    var email = normalizeOnboardingInviteEmail(field.val());

    if (field.val() !== email) {
      field.val(email);
    }

    if (email && !isValidOnboardingInviteEmail(email)) {
      field.addClass("error");
      return false;
    }

    field.removeClass("error");
    return !email || isValidOnboardingInviteEmail(email);
  }

  function validateOnboardingInviteEmails() {
    if (!$("#onboarding-invite-form").length) return true;

    var invalid = false;
    $("#onboarding-invite-rows .schedule-onboarding-invite-row").each(
      function () {
        if (
          !updateOnboardingInviteEmailField(
            $(this).find(".schedule-onboarding-invite-email")
          )
        ) {
          invalid = true;
        }
      }
    );

    if (invalid) {
      showOnboardingInviteMessage(
        "Fix invalid email addresses before continuing.",
        true
      );
      return false;
    }

    $("#onboarding-invite-message").hide().removeClass("error-message");
    return true;
  }

  if ($("#onboarding-invite-form").length) {
    $("#onboarding-invite-add")
      .off("click.onboardingInvite")
      .on("click.onboardingInvite", function (e) {
        e.preventDefault();
        var template = document.getElementById(
          "onboarding-invite-row-template"
        );
        if (!template) return;
        $("#onboarding-invite-rows").append(
          $(template.content.cloneNode(true))
        );
      });

    $("#onboarding-invite-rows")
      .off("blur.onboardingInvite", ".schedule-onboarding-invite-email")
      .on(
        "blur.onboardingInvite",
        ".schedule-onboarding-invite-email",
        function () {
          updateOnboardingInviteEmailField(this);
        }
      );

    $("#onboarding-invite-rows")
      .off("click.onboardingInvite", ".onboarding-invite-send")
      .on("click.onboardingInvite", ".onboarding-invite-send", function () {
        var button = $(this);
        var row = button.closest(".schedule-onboarding-invite-row");
        var form = $("#onboarding-invite-form");
        var input = row.find(".schedule-onboarding-invite-email");
        var email = normalizeOnboardingInviteEmail(input.val());
        var userType =
          row.find(".schedule-onboarding-invite-role").val() || "admin";
        var description =
          row.find(".schedule-onboarding-invite-description").val() ||
          "team_member";

        if (!updateOnboardingInviteEmailField(input) || !email) {
          showOnboardingInviteMessage(
            "Enter an email address to invite.",
            true
          );
          return;
        }

        button.prop("disabled", true).text("Sending...");

        $.ajax({
          url: form.attr("action"),
          method: "POST",
          dataType: "json",
          data: {
            authenticity_token: form
              .find('input[name="authenticity_token"]')
              .val(),
            email: email,
            user_type: userType,
            description: description,
            accounts_users: {
              account_id: form.data("account-id"),
            },
          },
        })
          .done(function (data) {
            if (data && data.already_invited) {
              showOnboardingInviteMessage(
                email + " is already invited.",
                true
              );
            } else {
              showOnboardingInviteMessage("Invite sent to " + email + ".");
            }
            input.prop("disabled", true);
            row
              .find(".schedule-onboarding-invite-role")
              .prop("disabled", true);
            row
              .find(".schedule-onboarding-invite-description")
              .prop("disabled", true);
            row.addClass("schedule-onboarding-invite-row-sent");
            button.text("Sent");
          })
          .fail(function () {
            button.prop("disabled", false).text("Send Invite");
            showOnboardingInviteMessage(
              "Could not invite " + email + ".",
              true
            );
          });
      });
  }

  $("#account-nav-promos .close").on("click", function () {
    $("#account-nav-promos").hide();

    setCookie("promos-hidden", "true");
  });
});
